import axios, { AxiosInstance } from "axios";

export const bearer = "010c6d4ccaab278c0ecd92d30a7b0d";
export const basePath = "https://pagesource.de:443/cockpit_0_9_3"

const apiClient: AxiosInstance = axios.create({
    baseURL: basePath+"/api",
    // a hanging CMS must fail the request, not stall the page forever
    timeout: 10000,
    headers: {
        "Authorization": "Bearer "+bearer,
        "Accept": "*/*",
        "Content-Type": "application/x-www-form-urlencoded",
        "Cache-Control":"no-cache",
        "Pragma" :  "",
    }
});
export default apiClient;